import request from '@/utils/request'

// 详情查询 
export function GetCourseDetail(params) {
    return request({
        url: '/api/MoocIndex/GetCourseDetail',
        method: 'get',
        params
    })
}
// 查询目录树 
export function GetIndexTree(params) {

    return request({
        url: '/api/MoocIndex/GetIndexTree',
        method: 'get',
        params
    })
}

// 查询课后练习 
export function GetLearnDetail(params) {

    return request({
        url: '/api/MoocIndex/GetLearnDetail',
        method: 'get',
        params
    })
}




// 查询评论列表
export function MoocTalkLoad(params) {
    return request({
        url: '/api/MoocTalk/Load',
        method: 'get',
        params
    })
}

// 添加评论 
export function MoocTalkAdd(data) {
    return request({
        url: '/api/MoocTalk/Add',
        method: 'post',
        data
    })
}

// 查询练习题目 
export function GetLearnLists(params) {
    return request({
        url: '/api/MoocIndex/GetLearnList',
        method: 'get',
        params
    })
}


// 下载资源列表 
export function MoocGetDownList(params) {
    return request({
        url: '/api/MoocIndex/GetDownList',
        method: 'get',
        params
    })
}

// 点击下载 
export function MoocGetDownFile(params) {
    return request({
        url: '/api/MoocIndex/GetDownFile',
        method: 'get',
        params
    })
}


// 查询目录大节点 
export function MoocGetListByPid(params) {
    return request({
        url: '/api/MoocCatalogue/GetListByPid',
        method: 'get',
        params
    })
}

// 查询文档资源 
export function GetCatalogue(params) {
    return request({
        url: '/api/MoocResource/GetCatalogue',
        method: 'get',
        params
    })
}

// 查询练习题 列表 
export function catalogueId(params) {
    return request({
        url: '/api/MoocQuestion/Load',
        method: 'get',
        params
    })
}


// 查询课件列表 
export function MoocQuestionList(params) {
    return request({
        url: '/api/MoocIndex/GetCourseList',
        method: 'get',
        params
    })
}

// 查询星级下面的列表
export function GetWkStartList(params) {
    return request({
        url: '/api/Home/GetWkStartList',
        method: 'get',
        params
    })
}

// 获取重点课程专题头部
export function GetDocHotWkName(params) {
    return request({
        url: '/api/Home/GetDocHotWkName',
        method: 'get',
        params
    })
}

// 查询重点课程列表 
export function GetCourseList(params) {
    return request({
        url: '/api/MoocSpecial/GetCourseList',
        method: 'get',
        params
    })
}

// 查询最受欢迎 
export function GetWkNewList(params) {
    return request({
        url: '/api/Home/GetWkNewList',
        method: 'get',
        params
    })
}


// 获取资源列表 
export function DocumentLoadList(params) {
    return request({
        url: '/api/Document/LoadQT',
        method: 'get',
        params
    })
}




// 查询更多慕课列表 
export function MoocCourseListSun(params) {
    return request({
        url: '/api/MoocCourse/Load',
        method: 'get',
        params
    })
}

// 获取教官讲师  
export function GetTeacherInfoList(params) {
    return request({
        url: '/api/MoocCourse/GetTeacherInfo',
        method: 'get',
        params
    })
}

// 添加播放记录
export function CourseRecordAdd(data) {
    return request({
        url: '/api/CourseRecord/Add',
        method: 'post',
        data
    })
}

// 查询播放记录 
export function CourseRecordLoad(params) {
    return request({
        url: '/api/CourseRecord/Load',
        method: 'get',
        params
    })
}